<script>
/* eslint-disable */
    export default {
        props: {
            show: Boolean,
            title: String,
            productInfo: Array,
            errors: Object,
        },
        methods:{
            contactUs(){
                window.parent.postMessage("iframeEvent", 'https://paygate.kz');
            }
        },
    }
</script>

<template>
    <div class="w-80 rounded-[10px] flex flex-col mt-10 md:mt-0 absolute bg-white border-[1px] border-[#59499A26] p-6 m-auto left-0 right-0 top-0 max-h-80 shadow" v-if="show">
        <div class="w-full flex justify-between">
            <p class="font-bold text-[#0F0C27] text-base" v-html="title"></p>
            <button @click="this.$emit('close')">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" class="w-7 h-7">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="flex w-full rounded-[10px] border-[1px] border-[#0F0C271A] p-4 mt-4 mb-4">
            <div class="flex flex-col justify-between w-full">
                <p class="font-medium text-xs color-[#0F0C27]">Доступные продукты</p>
                <div class="flex w-full mt-2 flex-wrap justify-between">
                    <div v-if="productInfo[0]" v-for="(value, name, index) in productInfo[0].available_products" class="w-[48%] h-10 flex justify-center items-center rounded-[5px] bg-[#59499A] mb-2 item" :class="value ? 'working' : 'not_working'">
                        <p class="text-white" v-html="name"></p>
                    </div>
                    <div v-else-if="productInfo.length <= 1"  class="w-full flex justify-center items-center rounded-[5px] bg-[#fafafa] h-[96px] p-2 text-center">
                        <p @click="t(productInfo[0].available_products)">Доступных продуктов<br> пока нет</p>
                    </div>                    
                </div>
            </div>
        </div>
<!--        <a class="w-full h-[48px] flex justify-center items-center bg-[#6FCF97] rounded-md text-white font-bold text-sm neon-btn" href="https://paygate.kz/contacts" target="_blank">Связаться</a>-->
    </div>
</template>

<style scoped>
    .item.not_working{
        background: #3F3D56;

    }

    .shimmer{
        display: inline-block;
        height: 1em;
        position: relative;
        overflow: hidden;
        background-color: #DDDBDD;
        height:96px;
    }

    .shimmer::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height:96px;
        transform: translateX(-100%);
        background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2049194677871149) 20%, rgba(255,255,255,0.5018382352941176) 60%, rgba(255,255,255,0) 100%);
        animation: shimmerBg 1s infinite;
        content: '';
    }

    @keyframes shimmerBg {
        100% {
            transform: translateX(100%);
        }
    }

    .neon-btn:hover{
        animation: pulse 2s linear infinite;
        transition: 2s;
    }

    @-webkit-keyframes pulse {
    0% {
        -webkit-box-shadow: 0px 0px 10px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 10px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 10px -4px rgba(111, 207, 151, 0.9);
    }

    15% {
        -webkit-box-shadow: 0px 0px 15px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 15px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 15px -4px rgba(111, 207, 151, 0.9);
    }

    25% {
        -webkit-box-shadow: 0px 0px 20px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 20px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 20px -4px rgba(111, 207, 151, 0.9);
    }
  
    35% {
        -webkit-box-shadow: 0px 0px 25px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 25px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 25px -4px rgba(111, 207, 151, 0.9);
    }

    50% {
        -webkit-box-shadow: 0px 0px 30px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 30px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 30px -4px rgba(111, 207, 151, 0.9);
    }

    65% {
        -webkit-box-shadow: 0px 0px 25px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 25px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 25px -4px rgba(111, 207, 151, 0.9);
    }

    75% {
        -webkit-box-shadow: 0px 0px 20px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 20px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 20px -4px rgba(111, 207, 151, 0.9);
    }

    85% {
        -webkit-box-shadow: 0px 0px 15px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 15px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 15px -4px rgba(111, 207, 151, 0.9);
    }

    100% {
        -webkit-box-shadow: 0px 0px 10px -4px rgba(111, 207, 151, 0.9);
        -moz-box-shadow: 0px 0px 10px -4px rgba(111, 207, 151, 0.9);
        box-shadow: 0px 0px 10px -4px rgba(111, 207, 151, 0.9);
    }
}

.non-focus:focus{
    box-shadow: none !important;
}
</style>